import GalleryButton  from './GalleryButton2';

export default GalleryButton ;